/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Stock from './Stock';
import Layout from '../../components/Layout/Layout';

function action(context) {
  const { code } = context.params;

  return {
    title: code,
    chunks: ['home'],
    component: (
      <Layout>
        <Stock code={code} />
      </Layout>
    ),
  };
}

export default action;
